import ApiClient from 'dashboard/api/ApiClient';

class GoldmanAPI extends ApiClient {
  constructor() {
    super('', { accountScoped: true });
  }

  getUser(contactId) {
    return axios.get(`${this.baseUrl()}/contacts/${contactId}/goldman`);
  }

  updateBalance(contactId, amount) {
    return axios.post(`${this.baseUrl()}/contacts/${contactId}/goldman/balance`, { amount });
  }

  addSubscription(contactId, months) {
    return axios.post(`${this.baseUrl()}/contacts/${contactId}/goldman/subscription`, { months });
  }

  adjustSubscription(contactId, days) {
    return axios.post(`${this.baseUrl()}/contacts/${contactId}/goldman/days`, { days });
  }

  cancelSubscription(contactId) {
    return axios.delete(`${this.baseUrl()}/contacts/${contactId}/goldman/subscription`);
  }

  toggleAutoRenew(contactId) {
    return axios.post(`${this.baseUrl()}/contacts/${contactId}/goldman/auto_renew`);
  }
}

export default new GoldmanAPI();
